/**
 * Type conversion utilities for event parameters
 * Matches backend convertValue logic to ensure preview consistency
 */

/**
 * Converts a string value to the appropriate type based on the parameter type
 * This matches the backend's convertValue method for consistent rendering
 *
 * @param value - The string value to convert
 * @param type - The parameter type (boolean, number, string, etc.)
 * @returns The converted value with the appropriate type
 */
export const convertValueByType = (value: string, type: string): any => {
  // Convert string booleans to actual booleans
  if (type.toLowerCase() === 'boolean') {
    if (value === 'true') return true;
    if (value === 'false') return false;
  }

  // Convert numeric strings to numbers for numeric types
  if (
    type.toLowerCase() === 'number' ||
    type.toLowerCase() === 'integer' ||
    type.toLowerCase() === 'float'
  ) {
    const num = Number(value);
    if (!isNaN(num) && value.trim() !== '') {
      return num;
    }
  }

  // Return as-is for strings and other types
  return value;
};

/**
 * Gets the default value for a parameter, applying type conversion
 *
 * @param example - The example value (string)
 * @param type - The parameter type
 * @returns The converted default value
 */
export const getDefaultValue = (example: string | undefined, type: string): any => {
  const defaultStr = example || 'Sample Value';
  return convertValueByType(defaultStr, type);
};
